// Ported from src/components/templates/TherapyDialogs/therapyFormatters.ts, using dayjs instead of moment
// (dayjs is already the date library used by components-new/inputs DatePickerNew / TimePickerNew).
import dayjs from 'dayjs'
import 'dayjs/locale/it'
import {DEVICE_OF_ASSUMPTION_OPTIONS, MODE_OF_ASSUMPTION_OPTIONS, WEEKDAY_OPTIONS} from './therapyOptions'

export const formatDate = (date?: string, format = 'DD/MM/YYYY'): string =>
  date ? dayjs(date).locale('it').format(format) : ''

// notificationTime can come as a plain 'HH:mm' string (mock data, legacy records) or as a full
// ISO datetime (TimePickerNew's onChange saves `toISOString()`) — dayjs can't parse 'HH:mm' as a
// date on its own, so that shape is returned as-is instead of going through dayjs.
export const formatTime = (time?: string): string => {
  if (!time) return ''
  if (/^\d{1,2}:\d{2}$/.test(time)) return time
  const parsed = dayjs(time)
  return parsed.isValid() ? parsed.format('HH:mm') : ''
}

export const formatUnitOfMeasure = (dosage?: {value?: number; unitType?: string}): string =>
  dosage?.value !== undefined && dosage?.value !== null ? `${dosage.value} ${dosage.unitType}` : ''

export const formatTherapyEach = (each?: {value?: number; unitType?: string}): string => {
  const {value, unitType} = each ?? {}
  switch (unitType) {
    case 'HOUR': return value === 1 ? '1 ora' : `${value} ore`
    case 'DAY': return value === 1 ? '1 giorno' : `${value} giorni`
    case 'WEEK': return value === 1 ? '1 settimana' : `${value} settimane`
    case 'MONTH': return value === 1 ? '1 mese' : `${value} mesi`
    default: return `${value} ${unitType}`
  }
}

export const formatWeekDay = (day: string): string => WEEKDAY_OPTIONS.find(({value}) => value === day)?.label ?? day

export const formatFrequencyDays = (days: string[] = []): string => days.map(formatWeekDay).join(', ')

export const formatModeOfAssumption = (modeKey?: string): string =>
  MODE_OF_ASSUMPTION_OPTIONS.find(({value}) => value === modeKey)?.label ?? modeKey ?? ''

export const formatDeviceOfAssumption = (deviceKey?: string): string =>
  DEVICE_OF_ASSUMPTION_OPTIONS.find(({value}) => value === deviceKey)?.label ?? deviceKey ?? ''

const THERAPY_STATE_LABELS: Record<string, string> = {
  ACTIVE: 'Attiva',
  NOT_ACTIVE: 'Non attiva'
}

export const formatTherapyState = (state?: string): string => state ? (THERAPY_STATE_LABELS[state] ?? state) : ''
